(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
  root.LuggexCompare = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  var IN_PER = { in: 1, inch: 1, inches: 1, cm: 1 / 2.54, mm: 1 / 25.4, m: 39.37007874, ft: 12, yd: 36 };
  var LB_PER = { lb: 1, lbs: 1, pound: 1, pounds: 1, oz: 0.0625, kg: 2.2046226218, g: 0.0022046226218 };
  var L_PER = { l: 1, liter: 1, liters: 1, ml: 0.001, cl: 0.01, m3: 1000, us_gal: 3.785411784, us_qt: 0.946352946, us_pt: 0.473176473, us_fl_oz: 0.0295735295625 };

  function toNumber(value) {
    var n = typeof value === 'number' ? value : parseFloat(value);
    return Number.isFinite(n) ? n : null;
  }

  function round4(n) {
    return Math.round(n * 10000) / 10000;
  }

  function normalizeDimension(value, unit) {
    var n = toNumber(value);
    if (n == null) return null;
    var factor = IN_PER[String(unit || 'in').toLowerCase()];
    if (!factor) return null;
    return round4(n * factor);
  }

  function normalizeWeight(value, unit) {
    var n = toNumber(value);
    if (n == null) return null;
    var factor = LB_PER[String(unit || 'lb').toLowerCase()];
    if (!factor) return null;
    return round4(n * factor);
  }

  function normalizeVolume(value, unit) {
    var n = toNumber(value);
    if (n == null) return null;
    var factor = L_PER[String(unit || 'l').toLowerCase()];
    if (!factor) return null;
    return round4(n * factor);
  }

  function rowKey(groupKey, fieldKey) {
    return String(groupKey) + '|' + String(fieldKey);
  }

  function isEmptyRaw(raw) {
    return raw === null || raw === undefined || raw === '';
  }

  function sameRaw(a, b) {
    if (isEmptyRaw(a) || isEmptyRaw(b)) return false;
    if (typeof a === 'number' && typeof b === 'number') return round4(a) === round4(b);
    return String(a) === String(b);
  }

  function allSameRaw(values) {
    if (!values.length) return false;
    var first = values[0];
    return values.every(function (value) {
      return sameRaw(first, value);
    });
  }

  function shouldRenderRow(row, columnRaws, hideSimilarities) {
    var empties = columnRaws.filter(isEmptyRaw).length;
    if (row.optional && empties === columnRaws.length) return false;
    if (hideSimilarities && empties === 0 && allSameRaw(columnRaws)) return false;
    return true;
  }

  function visibleRows(rows, columns, hideSimilarities) {
    return rows.filter(function (row) {
      var raws = columns.map(function (column) {
        var field = column.fields[row.key];
        return field ? field.raw : null;
      });
      return shouldRenderRow(row, raws, hideSimilarities);
    });
  }

  function isDuplicateSelection(handle, selectedHandles, columnIndex) {
    return takenIndex(handle, selectedHandles, columnIndex) >= 0;
  }

  function takenIndex(handle, selectedHandles, columnIndex) {
    for (var index = 0; index < selectedHandles.length; index++) {
      if (index !== columnIndex && selectedHandles[index] === handle) return index;
    }
    return -1;
  }

  function swapColumns(selectedHandles, columnIndex, otherIndex) {
    return selectedHandles.map(function (current, index) {
      if (index === columnIndex) return selectedHandles[otherIndex];
      if (index === otherIndex) return selectedHandles[columnIndex];
      return current;
    });
  }

  function replaceColumn(selectedHandles, columnIndex, handle) {
    var other = takenIndex(handle, selectedHandles, columnIndex);
    if (other >= 0) return swapColumns(selectedHandles, columnIndex, other);
    return selectedHandles.map(function (current, index) {
      return index === columnIndex ? handle : current;
    });
  }

  function productByHandle(catalog, handle) {
    return catalog.find(function (item) {
      return item.handle === handle;
    }) || null;
  }

  var SERIES_ORDER = ['ZX', 'FX', 'EX', 'UX', 'other'];
  var SERIES_LABEL = { ZX: 'ZX', FX: 'FX', EX: 'EX', UX: 'UX', other: 'Other' };

  function normalizeSeries(value) {
    if (value == null || value === '') return '';
    var key = String(value).trim();
    if (key.toLowerCase() === 'other') return 'other';
    var up = key.toUpperCase();
    if (up === 'ZX' || up === 'FX' || up === 'EX' || up === 'UX') return up;
    return '';
  }

  function seriesOf(product) {
    var explicit = normalizeSeries(product && product.series);
    if (explicit) return explicit;
    var handle = String(product && product.handle || '').toLowerCase();
    if (handle.indexOf('zx-') === 0) return 'ZX';
    if (handle.indexOf('ex-') === 0) return 'EX';
    if (handle.indexOf('fx-') === 0 || handle.indexOf('top-open') !== -1) return 'FX';
    if (handle.indexOf('ux-') === 0 || handle.indexOf('underseat') !== -1) return 'UX';
    return 'other';
  }

  function groupCatalogBySeries(catalog) {
    var buckets = { ZX: [], FX: [], EX: [], UX: [], other: [] };
    (catalog || []).forEach(function (product) {
      var key = seriesOf(product);
      if (!buckets[key]) key = 'other';
      buckets[key].push(product);
    });
    return SERIES_ORDER.filter(function (key) {
      return buckets[key].length > 0;
    }).map(function (key) {
      return { key: key, label: SERIES_LABEL[key], products: buckets[key] };
    });
  }

  function applySeed(catalog, seedByHandle) {
    return (catalog || []).map(function (product) {
      var seed = seedByHandle && seedByHandle[product.handle];
      if (!seed) return Object.assign({}, product, { series: seriesOf(product) });
      var fields = Object.assign({}, product.fields);
      Object.keys(seed.fields || {}).forEach(function (key) {
        var current = fields[key];
        if (!current || isEmptyRaw(current.raw)) {
          fields[key] = seed.fields[key];
        }
      });
      var title = product.title;
      if (seed.display_title && !product.displayTitleSet) {
        title = seed.display_title;
      }
      var series = normalizeSeries(product.series) || normalizeSeries(seed.series) || seriesOf(product);
      return Object.assign({}, product, { title: title, fields: fields, series: series });
    });
  }

  function applyOverrides(catalog, overridesByHandle) {
    return (catalog || []).map(function (product) {
      var over = overridesByHandle && overridesByHandle[product.handle];
      if (!over) return product;
      var fields = Object.assign({}, product.fields);
      Object.keys(over.fields || {}).forEach(function (key) {
        var value = over.fields[key];
        if (!value) return;
        var raw = value.raw;
        var display = value.display;
        if (isEmptyRaw(raw) && (display == null || display === '')) return;
        fields[key] = {
          raw: isEmptyRaw(raw) ? display : raw,
          display: display == null || display === '' ? String(raw) : display
        };
      });
      var title = over.display_title ? over.display_title : product.title;
      return Object.assign({}, product, { title: title, fields: fields });
    });
  }

  function columnCount(isMobile) {
    return isMobile ? 2 : 3;
  }

  return {
    normalizeDimension: normalizeDimension,
    normalizeWeight: normalizeWeight,
    normalizeVolume: normalizeVolume,
    rowKey: rowKey,
    isEmptyRaw: isEmptyRaw,
    sameRaw: sameRaw,
    allSameRaw: allSameRaw,
    shouldRenderRow: shouldRenderRow,
    visibleRows: visibleRows,
    isDuplicateSelection: isDuplicateSelection,
    takenIndex: takenIndex,
    swapColumns: swapColumns,
    replaceColumn: replaceColumn,
    productByHandle: productByHandle,
    applySeed: applySeed,
    applyOverrides: applyOverrides,
    seriesOf: seriesOf,
    groupCatalogBySeries: groupCatalogBySeries,
    columnCount: columnCount
  };
});
